import { useStore } from 'react-admin';
import { Box, Button, ButtonGroup } from '@mui/material';
import ViewListIcon from '@mui/icons-material/ViewList';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { SupplyList } from './list/SupplyList';
import { SupplyInventoryByAntenna } from './inventory/SupplyInventoryByAntenna';

type SupplyTabView = 'list' | 'inventory';

export const SupplyTab = () => {
    const [supplyTabView, setSupplyTabView] = useStore<SupplyTabView>(
        'supplyTabView',
        'list'
    );

    return (
        <Box>
            <Box display="flex" justifyContent="flex-end" mb={2}>
                <ButtonGroup size="small" variant="outlined">
                    <Button
                        onClick={() => setSupplyTabView('list')}
                        startIcon={<ViewListIcon />}
                        variant={
                            supplyTabView === 'list' ? 'contained' : 'outlined'
                        }
                    >
                        List
                    </Button>
                    <Button
                        onClick={() => setSupplyTabView('inventory')}
                        startIcon={<Inventory2OutlinedIcon />}
                        variant={
                            supplyTabView === 'inventory'
                                ? 'contained'
                                : 'outlined'
                        }
                    >
                        Inventory by antenna
                    </Button>
                </ButtonGroup>
            </Box>

            <Box sx={{ width: '100%', marginTop: '-20px' }}>
                {supplyTabView === 'list' && <SupplyList />}
                {supplyTabView === 'inventory' && <SupplyInventoryByAntenna />}
            </Box>
        </Box>
    );
};
